import React from 'react'
const User = ({ width = 20, height = 20, color = '#fff' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 16.25C17.5 13.4886 15.2614 11.25 12.5 11.25H7.5C4.73858 11.25 2.5 13.4886 2.5 16.25V17.9167H17.5V16.25ZM7.5 12.0833H12.5L12.6807 12.0872C14.8981 12.1818 16.6667 14.0094 16.6667 16.25V17.0833H3.33333V16.25L3.33718 16.0693C3.43182 13.8519 5.25937 12.0833 7.5 12.0833Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.08334 16.2507C2.08334 13.2591 4.50847 10.834 7.50001 10.834H12.5C15.4916 10.834 17.9167 13.2591 17.9167 16.2507V18.334H2.08334V16.2507ZM2.91669 16.2418C2.9168 16.1797 2.91816 16.1179 2.92072 16.0564L2.91669 16.2418ZM12.5089 11.6673C12.571 11.6674 12.6328 11.6688 12.6943 11.6714L12.5089 11.6673ZM3.75367 16.0833L3.75001 16.2551V16.6673H16.25V16.2507C16.25 14.2356 14.6606 12.5917 12.6673 12.5043L12.4956 12.5007H7.50001C5.48501 12.5007 3.84102 14.0901 3.75367 16.0833Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.83334 5.83268C5.83334 3.5315 7.69882 1.66602 10 1.66602C12.3012 1.66602 14.1667 3.5315 14.1667 5.83268V6.24935C14.1667 8.55054 12.3012 10.416 10 10.416C7.69882 10.416 5.83334 8.55054 5.83334 6.24935V5.83268ZM10 3.33268C8.6193 3.33268 7.50001 4.45197 7.50001 5.83268V6.24935C7.50001 7.63006 8.6193 8.74935 10 8.74935C11.3807 8.74935 12.5 7.63006 12.5 6.24935V5.83268C12.5 4.45197 11.3807 3.33268 10 3.33268Z"
      fill={color}
    />
  </svg>
)
export default User
